import React from 'react';

export const money = (n) => `₹${(Number(n) || 0).toFixed(2)}`;

export function UsageBadge({ usage }) {
  if (!usage) return null;
  const credits = Number(usage.credits) || 0;
  const wallet = Number(usage.wallet) || 0;
  const low = credits < 0.5 && wallet < 0.5;
  return (
    <span className={`ec-badge ${low ? 'ec-badge-orange' : 'ec-badge-grey'}`}
      title="1 credit = ₹1. New lookups use credits first, then your wallet. Saved results are free.">
      {credits.toFixed(2)} credits · {money(wallet)} wallet
    </span>
  );
}

export function Cost({ prices, kind }) {
  if (!prices || prices[kind] == null) return null;
  return <span className="cite-cost">{Number(prices[kind]).toFixed(2)}</span>;
}

/** Attribution required by Indian Kanoon's API terms. */
export function PoweredBy() {
  return (
    <p className="small ec-muted mt-4 mb-0">
      Judgments and citations powered by{' '}
      <a href="https://indiankanoon.org" target="_blank" rel="noopener noreferrer" className="ec-link">Indian Kanoon</a>.
      Always check the certified copy before relying on a judgment.
    </p>
  );
}

export function fmtDate(v) {
  if (!v) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v));
  if (!m) return String(v);
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
}

/** Unix seconds → local date & time (IST for Indian users). */
export function fmtTs(ts) {
  const d = ts ? new Date(Number(ts) * 1000) : null;
  if (!d || Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export function JudgmentRow({ to, title, court, date, snippet, citedBy, LinkComponent }) {
  const L = LinkComponent;
  return (
    <L to={to} className="ec-result">
      <div className="ec-result-title">{title || 'Untitled judgment'}</div>
      {(court || date) && <div className="small ec-muted">{[court, fmtDate(date)].filter(Boolean).join(' · ')}</div>}
      {snippet && <div className="small mt-1 cite-snippet">{snippet}</div>}
      {citedBy ? <div className="small ec-muted mt-1">Cited by {Number(citedBy).toLocaleString('en-IN')}</div> : null}
    </L>
  );
}